import React from "react";

import PropTypes from "prop-types";

import { useDictionary } from "hooks";

const styles = { width: "95%" };

const SettingsTab = ({ CustomSettingsComponent, parentQuestionConfig, onChangeConfig }) => {
	const dictionary = useDictionary("simplifiedBuilder.components.SettingsTab");

	return (
		<>
			{CustomSettingsComponent && (
				<CustomSettingsComponent
					parentQuestionConfig={parentQuestionConfig}
					onChangeConfig={onChangeConfig}
				/>
			)}
			<label className="ui input">
				<p><strong>{dictionary.tooltip}</strong>{dictionary.tooltipExplanation}</p>
				<input
					style={styles}
					value={parentQuestionConfig.tooltip || parentQuestionConfig.extraSettings.tooltip || ""}
					placeholder={dictionary.tooltipLabel}
					onChange={event => onChangeConfig({ tooltip: event.target.value })}
				/>
			</label>
			<label className="ui input">
				<p><strong>{dictionary.description}</strong>{dictionary.descriptionExplanation}</p>
				<input
					style={styles}
					value={parentQuestionConfig.description || ""}
					placeholder={dictionary.descriptionLabel}
					onChange={event => onChangeConfig({ description: event.target.value })}
				/>
			</label>
		</>
	);
};

SettingsTab.defaultProps = {
	CustomSettingsComponent: null,
};

SettingsTab.propTypes = {
	CustomSettingsComponent: PropTypes.elementType,
	parentQuestionConfig: PropTypes.any.isRequired,
	onChangeConfig: PropTypes.func.isRequired,
};


export default SettingsTab;
